/** Shared table cell styles for schema/type lists — §6.8.7 */

export function schemaTableHeader(c, ap, extra = {}) {
  return {
    textAlign: "left",
    padding: "11px 14px",
    color: c.sub,
    fontWeight: 700,
    fontSize: 10.5,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    borderBottom: `1px solid ${ap.cardBorder}`,
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    background: c.hover,
    zIndex: 1,
    ...extra,
  };
}

export function schemaTableCell(c, extra = {}) {
  return { padding: "14px", borderBottom: `1px solid ${c.divider}`, color: c.text, ...extra };
}
